export default {
  search_all: '搜索所有服务',
  explore_docs: '查看文档',
  products_features: '功能特性',
  products_key_benefits: '服务优势',
  products_typical_application: '使用场景',
  products_help_guides: '指南与帮助',
  products_more_details: '服务详情',
  products_more_details_desc: '查看产品文档了解更多详细信息',
  products_more_try_now: '立即试用',
  products_more_try_now_desc: '立即登录InGame平台，体验各项服务功能',
  products_more_contact_us: '联系我们',
  products_more_contact_us_desc: 'InGame平台服务专家将尽快回复您的问题',
  no_search_result: '没有搜索结果',
  put_away: '收起',
  more: '更多',
};
